import { translate } from '../../../../util/translate'

export const hausefulTakeRateInvoices = [
  { text: translate['hausefulInvoices.headers.date'], value: 'created_at', width: '10vw' },
  { text: translate['hausefulInvoices.headers.createdBy'], value: 'created_by', width: 400 },
  { text: translate['hausefulInvoices.headers.realEstate'], value: 'real_estate', width: 400 },
  { text: translate['hausefulInvoices.headers.branch'], value: 'branch', width: '25vw' },
  { text: translate['hausefulInvoices.headers.emission'], value: 'asaas_invoice', width: 180 },
  { text: translate['hausefulInvoices.headers.paymentLink'], value: 'payment_link', align: 'center', width: 150 },
  { text: translate['hausefulInvoices.headers.invoiceFile'], value: 'file_response', align: 'center', width: 90 },
  { text: translate['hausefulInvoices.headers.actions'], value: 'actions', align: 'end', width: 150 },
]

export const hausefulTakeRateInvoicesSummary = [
  {
    text: translate['hausefulInvoices.headers.creation'],
    value: 'created_at',
    sortable: false,
    width: 100,
  },
  {
    text: translate['hausefulInvoices.headers.host'],
    value: 'host.name',
    sortable: false,
    width: 140,
  },
  {
    text: translate['hausefulInvoices.headers.realties'],
    value: 'realty_quantity',
    sortable: false,
    align: 'center',
    width: 20,
  },
  {
    text: translate['hausefulInvoices.headers.total'],
    value: 'total',
    sortable: false,
    align: 'right',
    width: 20,
  },
]
